import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoardView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 1.5,
			width: 5,
			height: 3,
			rx: .576923,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 6.5,
			width: 5,
			height: 3,
			rx: .576923,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 11.5,
			width: 5,
			height: 3,
			rx: .576923,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 1.5,
			width: 5,
			height: 3,
			rx: .576923,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 6.5,
			width: 5,
			height: 3,
			rx: .576923,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 11.5,
			width: 5,
			height: 3,
			rx: .576923,
			stroke: "currentColor"
		})
	]
});
export default SvgBoardView;
